import { render, staticRenderFns } from "./LoginRecuperarSenhaEmail.vue?vue&type=template&id=45f6c53b&"
import script from "./LoginRecuperarSenhaEmail.vue?vue&type=script&lang=js&"
export * from "./LoginRecuperarSenhaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports